export const isValidEmail = (str) =>
  /^[a-z0-9._%+-]+@[a-z0-9.-]+\.(\bbradesco\b|[a-z]{2,4})$/i.test(str);
